export { TaxonomyPage } from "./ui/taxonomy-page"
